import { Layout } from '../components/Layout';
import { EmailOTPSetupForm } from '../components/EmailOTPSetupForm';

export const EmailOTPSetup = () => {
  return (
    <Layout title="Email OTP Setup">
      <EmailOTPSetupForm />
    </Layout>
  );
};
